import { z } from 'zod'

/** every status except ONLINE closes the portal for users and api calls */
export const SystemStatus = z.enum(['ONLINE', 'MAINTENANCE'])

export type SystemStatus = z.infer<typeof SystemStatus>

export interface SystemStatusResponse {
  status: SystemStatus
}
